// extracted by mini-css-extract-plugin
export default {"color":"#5c6c73","container":"lib-component-mappings-sky-parallax-components-Cart-SecureCheckoutLabel-styles-module__container--JLFam"};